// extracted by mini-css-extract-plugin
module.exports = {"board":"BoardDisplay_board__2KCnn","square":"BoardDisplay_square__gjGKI","winningSquare":"BoardDisplay_winningSquare__sw8Gw","spin":"BoardDisplay_spin__2P20w"};